import { LINKS } from "./links";

export const SERVICES = {
  GESTION_CONTRIBUTI: {
    title: "Gestione contributi",
    content: "Gestione in toto dei contributi italiani ed europei",
    image:
      "/images/finance/PROSSIMITI-FINANZAAGEVOLATA-Servizio-Consulenza40-thumb.jpg",
    button: {
      title: "LE NOSTRE SOLUZIONI",
      link: LINKS.GESTIONE_CONTRIBUTI,
    },
  },
  PERIZIA_4: {
    title: "Perizie Industria 4.0",
    content: "Perizie per l'accesso al credito del piano transizione 4.0",
    image: "/images/services/Perizie_Industria_4_0.jpg",
    button: {
      title: "LE NOSTRE SOLUZIONI",
      link: LINKS.PERIZIE_4,
    },
  },
  CERTIFICAZIONE_5: {
    title: "Certificazione industria 5.0",
    content:
      "Certificazione ex ante, ex post e comunicazioni al Gse per Industria 5.0",
    image: "/images/services/Certificazione_Industria_5_0.png",
    button: {
      title: "LE NOSTRE SOLUZIONI",
      link: LINKS.CERTIFICAZIONE_5,
    },
  },
  PERIZIE_INAIL: {
    title: "Perizie Bando Isi Inail",
    content: "Perizie per presentare domanda al bando Isi Inail",
    image: "/images/services/Perizie_bando_isi_inail.jpg",
    button: {
      title: "LE NOSTRE SOLUZIONI",
      link: LINKS.PERIZIE_INAIL,
    },
  },
  SOFTWARE_MES_4: {
    title: "Software Mes 4.0",
    content: "Software per il monitoraggio dei propri processi produttivi",
    image: "/images/services/Software_Mes_4_0.jpg",
    button: {
      title: "LE NOSTRE SOLUZIONI",
      link: LINKS.SOFTWARE_MES_4,
    },
  },
};
